export default __webpack_public_path__ + "static/media/CryptoLogically - 793.ed6e4759.jpeg";